import Vue from "vue";
import VueAMap, { lazyAMapApiLoaderInstance } from "vue-amap";
import { polyfillAMapEvent } from "../utils/amap-event-polyfill";

const AMAP_KEY = process.env.VUE_APP_AMAP_KEY || "eb63e11ebf15625126149e5b15d79931";
const AMAP_SECURITY_JS_CODE = process.env.VUE_APP_AMAP_SECURITY_JS_CODE || "";

if (AMAP_SECURITY_JS_CODE) {
  window["_AMapSecurityConfig"] = {
    securityJsCode: AMAP_SECURITY_JS_CODE,
  };
}

Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
  key: AMAP_KEY,
  v: "2.0",
  plugin: [
    "AMap.MoveAnimation",
    "AMap.Scale",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.AutoComplete",
    "AMap.PlaceSearch",
  ],
});

export function loadAMap() {
  if (!lazyAMapApiLoaderInstance) {
    return Promise.reject(new Error("AMap loader 未初始化"));
  }
  return lazyAMapApiLoaderInstance.load().then(() => {
    polyfillAMapEvent();
    return window.AMap;
  });
}

loadAMap().catch((err) => {
  console.error("高德 JSAPI 2.0 加载失败", err);
});
